module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_ALLERGIEN_hauptseite-hintergrund.6a5176cb.jpg";